import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "admin.show_keys";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  window.addEventListener("storage", cb);
  return () => {
    listeners.delete(cb);
    window.removeEventListener("storage", cb);
  };
}

/** One global "Show keys" toggle, persisted in localStorage. */
export function useShowKeys(): { showKeys: boolean; toggle: () => void } {
  const showKeys = useSyncExternalStore(subscribe, read, () => false);
  const toggle = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, read() ? "0" : "1");
    } catch {
      /* storage unavailable: toggle is a no-op */
    }
    listeners.forEach((l) => l());
  }, []);
  return { showKeys, toggle };
}
